<template>
    <v-dialog v-model="dialogfilter" width="1000px" scroll-strategy="none">
        <v-card :retain-focus="false" min-width="700px" class="pa-4 py-2"
            style="background-color:white; border-radius: 12px; overflow-y: hidden;">
            <h1>{{ $t('ColumnFilter.searchBy', { itm: title }) }}</h1>

            <div class="row">
                <div class="col-4 justify-content-start">
                    <div class="row">
                        <v-card-title class="text-left ma-3 pl-0 custom-card-title">{{ $t('purchaseOrder.reference')
                            }}</v-card-title>
                    </div>
                    <v-text-field v-model="filterParams.Reference" id="Reference" name="Reference" maxlength="50"
                        hide-details persistent-placeholder
                        :placeholder="$t('placeholder.enter', { itm: $t('invoices.reference') })" variant="outlined"
                        class="mt-n4"></v-text-field>
                </div>
                <div class="col-4 justify-content-start">
                    <div class="row">
                        <v-card-title class="text-left ma-3 pl-0 custom-card-title">{{ $t('invoices.title')
                            }}</v-card-title>
                    </div>
                    <v-text-field v-model="filterParams.Title" id="Title" name="Title" maxlength="30" hide-details
                        persistent-placeholder :placeholder="$t('placeholder.enter', { itm: $t('invoices.title') })"
                        variant="outlined" class="mt-n4"></v-text-field>
                </div>
                <div v-if="!isSupplier" class="col-4 justify-content-start">
                    <div class="row">
                        <v-card-title class="text-left ma-1 pl-0 custom-card-title">{{ $t('purchaseOrder.supplier')
                            }}</v-card-title>
                    </div>
                    <div class="row">
                        <v-autocomplete id="Supplier" name="Supplier" class="pl-2" variant="outlined"
                            v-model="filterParams.Supplier" v-model:search="SupplierSearch" persistent-placeholder
                            :placeholder="filterParams.Supplier.length == 0 ? $t('placeholder.select', { itm: $t('purchaseOrder.supplier') }) : ''"
                            :items="SupplierList" item-title="brandName" item-value="brandName" hide-details multiple>
                            <template v-slot:item="{ props, item, index }">
                                <v-list-item v-bind="props" variant="text" :id="index" :name="item.brandName"
                                    @click="removeSupplier(item)">
                                    {{ item.brandName }}
                                </v-list-item>
                            </template>
                            <template v-slot:selection="{ props, item, index }">
                                <v-chip v-if="index < 1" v-bind="props" variant="text" :id="index" :name="item.title">
                                    {{ filterParams.Supplier.length <= 1 ? item.title : filterParams.Supplier.length + ' ' + $t('suppliers.supplierSelected') }} </v-chip>
                            </template>
                        </v-autocomplete>
                    </div>
                </div>
                <!-- Champ de montantTTC (Range) -->
                <div class="col-4 justify-content-start">
                    <div class="row">
                        <v-card-title class="text-left ma-3 pl-0 custom-card-title">{{ $t('invoices.MinamountTTC')
                            }}</v-card-title>
                    </div>
                    <v-text-field v-model="filterParams.MinAmountTTC" maxlength="9"
                        @update:model-value="validateAmounts"
                        hide-details :placeholder="$t('placeholder.enter', { itm: $t('invoices.MinamountTTC') })"
                        variant="outlined" class="mt-n4 text-left"></v-text-field>
                        <span v-if="errors.minAmount" class="error-message">{{ errors.minAmount }}</span>

                </div>
                <div class="col-4 justify-content-start">
                    <div class="row">
                        <v-card-title class="text-left ma-3 pl-0 custom-card-title">{{ $t('invoices.MaxamountTTC')
                            }}</v-card-title>
                    </div>
                    <v-text-field v-model="filterParams.MaxAmountTTC" maxlength="9"
                        @update:model-value="validateAmounts"
                        hide-details :placeholder="$t('placeholder.enter', { itm: $t('invoices.MaxamountTTC') })"
                        variant="outlined" class="mt-n4 text-left"></v-text-field>
                        <span v-if="errors.maxAmount" class="error-message">{{ errors.maxAmount }}</span>
                </div>

                <div class="col-4 justify-content-start">
                    <div class="row">
                        <v-card-title class="text-left ma-3 pl-0 custom-card-title">{{ $t('invoices.deadline')
                            }}</v-card-title>
                    </div>
                    <dateField id="ExpirationDate" name="ExpirationDate" v-model="filterParams.Deadline"
                        :model-value="filterParams.Deadline" :min-date="new Date('2000-01-01')"
                        range-enabled @update:model-value="handleDateRangeDeadline" class="mt-n4" ref="dateFieldRef" />
                </div>

                <div class="col-4 justify-content-start">
                    <div class="row">
                        <v-card-title class="text-left ma-3 pl-0 custom-card-title">{{ $t('invoices.creationDate')
                            }}</v-card-title>
                    </div>
                    <dateField id="CreationDate" name="CreationDate" v-model="CreationDate"
                        :min-date="new Date('2000-01-01')" :max-date="new Date()" :model-value="CreationDate"
                        range-enabled @update:model-value="handleDateRangeCreationDate" class="mt-n4"
                        ref="creationDateRef" position="top" :defaultvalue="filterParams.Deadline" />
                </div>
                <div class="col-12 justify-content-start">
                    <div class="row">
                        <v-card-title class="text-left ma-3 pl-0 custom-card-title">{{ $t('invoices.status')
                            }}</v-card-title>
                    </div>
                    <div class="d-flex align-items-center mt-n4" style="justify-content: center;">
                        <v-checkbox-group multiple class="d-flex flex-row" style="margin-top: 10px;">
                            <v-checkbox v-model="ValidationStatus" :label="isSubmitted" :value="0" id="Submitted"
                                name="ValidationStatus" class="mr-4"></v-checkbox>
                            <v-checkbox v-model="ValidationStatus" :label="isRefused" :value="1" id="Refused"
                                name="ValidationStatus" class="mr-4"></v-checkbox>
                            <v-checkbox v-model="ValidationStatus" :label="isValidated" :value="2" id="Validated"
                                name="ValidationStatus" class="mr-4"></v-checkbox>
                            <v-checkbox v-model="ValidationStatus" :label="isPaid" :value="3" id="Paid"
                                name="ValidationStatus" class="mr-4"></v-checkbox>
                        </v-checkbox-group>
                    </div>
                </div>
            </div>
            <div class="d-flex justify-content-center align-items-center">
                <card-actions :yes="confirm" v-model="dialogfilter" :no="dialogfilter"  width="100px"
                    :yesTitle="$t('ColumnFilter.search')" @update:no="cancel">
                    <template v-slot:centerButton>
                        <genericBtnComponent width="100px" :ClickFun="cleardialogfilter"
                            :Title="$t('invoices.clearBtn')" />
                    </template>
                </card-actions>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
import cardActions from "@/genericComponent/cardActions.vue";
import dateField from "@/genericComponent/date-field.vue";
import { status } from "@/enums/Status";
import { GetSupplierFromInvoices , isSupplier} from "@/api/index";
import genericBtnComponent from "@/genericComponent/genericBtnComponent.vue"

export default {
   
    components: {
        cardActions,
        dateField,
        genericBtnComponent
    },
    data() {
        return {
            filterParams: {
                Reference: null,
                Title: null,
                Supplier: [],
                MinAmountTTC: null,
                MaxAmountTTC: null,
                DeadlineFrom: null,
                DeadlineTo: null,
                CreatedFrom: null,
                CreatedTo: null,
                Deadline: [],
            },
            errors: {
                minAmount: '',
                maxAmount: ''
            },
            dialogfilter: true,
            SupplierSearch: null,
            SupplierList: null,
            CreationDate: [],
            ValidationStatus: [],
            dateFieldRef: null,
            creationDateRef: null,
            isSupplier : isSupplier()
        };
    },

    created() {
        this.GetSupplierList();
    },

    methods: {
        GetSupplierList() {
            GetSupplierFromInvoices(this.SupplierSearch)
                .then((res) => {
                    this.SupplierList = res.data;
                })
        },
        removeSupplier(selectedItem) {
            this.filterParams.Supplier.filter(i => i != selectedItem);
        },
        confirm() {
            this.$emit('update:filteredInvoices',
                this.filterParams.Reference,
                this.filterParams.Title,
                this.filterParams.Supplier,
                this.filterParams.MinAmountTTC,
                this.filterParams.MaxAmountTTC,
                this.filterParams.DeadlineFrom,
                this.filterParams.DeadlineTo,
                this.filterParams.CreatedFrom,
                this.filterParams.CreatedTo,
                this.ValidationStatus,
                this.filterParams.Deadline,
            );
        },
        cancel() {
            this.$emit('cancel');
        },
        cleardialogfilter() {
            this.filterParams.Reference = null;
            this.filterParams.Title = null;
            this.filterParams.Supplier = [];
            this.filterParams.MinAmountTTC = null;
            this.filterParams.MaxAmountTTC = null;
            this.filterParams.DeadlineFrom = null;
            this.filterParams.DeadlineTo = null;
            this.filterParams.CreatedFrom = null;
            this.filterParams.CreatedTo = null;
            this.filterParams.Deadline = [];
            this.CreationDate = [];
            this.ValidationStatus = [];
            if (this.$refs.dateFieldRef && this.$refs.creationDateRef) {
                this.$refs.dateFieldRef.clearDateRange();
                this.$refs.creationDateRef.clearDateRange();

            }
            this.errors.minAmount = '';
            this.errors.maxAmount = '';
        },
        validateAmounts() {
            this.errors.minAmount = '';
            this.errors.maxAmount = '';
            this.filterParams.MinAmountTTC = this.filterParams.MinAmountTTC ? this.filterParams.MinAmountTTC.replace(/[^0-9.]/g, '') : null;
            this.filterParams.MaxAmountTTC = this.filterParams.MaxAmountTTC ? this.filterParams.MaxAmountTTC.replace(/[^0-9.]/g, '') : null;

            const minAmount = parseFloat(this.filterParams.MinAmountTTC);
            const maxAmount = parseFloat(this.filterParams.MaxAmountTTC);

            if (!isNaN(minAmount) && !isNaN(maxAmount)) {
                if (minAmount > maxAmount) {
                    this.errors.minAmount = this.$t('invoices.validationTab.minAmountGreater');
                    this.errors.maxAmount = this.$t('invoices.validationTab.maxAmountSmaller');
                }

            }
        },
        handleDateRangeDeadline(value) {
            if (Array.isArray(value) && value.length === 2) {
                this.filterParams.DeadlineFrom = value[0];
                this.filterParams.DeadlineTo = value[1];
            }
            else {
                this.filterParams.DeadlineFrom = null;
                this.filterParams.DeadlineTo = null;
                this.filterParams.Deadline = [];
            }
        },
        handleDateRangeCreationDate(value) {
            if (Array.isArray(value) && value.length === 2) {
                this.filterParams.CreatedFrom = value[0];
                this.filterParams.CreatedTo = value[1];
            }
        },

    },


    watch: {
        SupplierSearch(value) {
            if (this.SupplierSearch != null && this.SupplierSearch.length == 1) this.SupplierSearch = value.trim();
            this.GetSupplierList();
        },
    },
    computed: {


        isSubmitted() {
            return localStorage.getItem(status.Submitted + this.$i18n.locale);
        },
        isPaid() {
            return localStorage.getItem(status.Paid + this.$i18n.locale);
        },
        isRefused() {
            return localStorage.getItem(status.Refused + this.$i18n.locale);
        },
        isValidated() {
            return localStorage.getItem(status.Validated + this.$i18n.locale);
        }

    },

};
</script>

<style scoped>
h1 {
    font-family: inter;
    font-size: 18px;
    line-height: 29px;
    font-weight: 600;
    color: #0d0849;
    text-align: center;
}

.custom-card-title {
    font-size: 16px;
    color: #5b6d8e;
}
.error-message {
    color: red;
    font-size: 14px;
}
</style>